import templatePreview from "../../assets/tracksmith.png";
let tracksmithImg = window.wpmNotificationPluginBuildUrl + templatePreview;
const downloadId = "602";
const tracksmith = [
  {
    id: "tracksmith_wp-signup-admin",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-signup-admin",
    downloadId,
  },
  {
    id: "tracksmith_wp-signup-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-signup-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-lost-password-admin",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-lost-password-admin",
    downloadId,
  },
  {
    id: "tracksmith_wp-lost-password-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-lost-password-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-password-changed-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-password-changed-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-change-user-email-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-change-user-email-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-changed-user-email-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-changed-user-email-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-comment-in-moderation-admin",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-comment-in-moderation-admin",
    downloadId,
  },
  {
    id: "tracksmith_wp-comment-published-post-author",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-comment-published-post-author",
    downloadId,
  },
  {
    id: "tracksmith_wp-change-site-admin-email",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-change-site-admin-email",
    downloadId,
  },
  {
    id: "tracksmith_wp-changed-site-admin-email",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-changed-site-admin-email",
    downloadId,
  },
  {
    id: "tracksmith_wp-request-personal-data-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-request-personal-data-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-confirmed-personal-data-request-admin",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-confirmed-personal-data-request-admin",
    downloadId,
  },
  {
    id: "tracksmith_wp-download-personal-data-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-download-personal-data-user",
    downloadId,
  },
  {
    id: "tracksmith_wp-erased-personal-data-user",
    image: tracksmithImg,
    label: "Tracksmith",
    category: "wp-erased-personal-data-user",
    downloadId,
  },
];

export default tracksmith;
